import { useFormik } from 'formik';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Button from '../../bootstrap/Button';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import Spinner from '../../bootstrap/Spinner';
import Checks, { ChecksGroup } from '../../bootstrap/forms/Checks';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';
import Label from '../../bootstrap/forms/Label';
import Textarea from '../../bootstrap/forms/Textarea';
// Database
import { where } from 'firebase/firestore';
import { DefaultContext } from '../../../contexts/default';
import CategoryDB from '../../../database/wrappers/category';
import ProductDB from '../../../database/wrappers/product';
import SubCategoryDB from '../../../database/wrappers/subCategory';
import SuggestionDB from '../../../database/wrappers/suggestion';
import PreAlert from '../../../helpers/utils/preAlert';
import Avatar from '../../MyCustom/Avatar';
import ListProducts from '../../MyCustom/ListProducts';
import Nav, { NavItem } from '../../bootstrap/Nav';
import Select from '../../bootstrap/forms/Select';
import ListSubCategories from './ListSubCategories';
import UserHistory from '../../../database/wrappers/userHistory';

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Este campo é necessário';
  } else if (values.name.length < 4) {
    errors.name = 'O nome precisa ter 3 caracteres ou mais';
  }

  if (isNaN(Number(values.order)) || Number(values.order) < 0 || Number(values.order) > 99) {
    errors.order = "Informe um número entre 0 e 99";
  }

  if (!values.active) {
    errors.active = 'Você precisa escolher o status da categoria';
  }

  return errors;

}

const ModalRegisterCategories = ({ open, setIsOpen, setIsClose, categorySelected }) => {

  const { establishment, onShowAlert, user } = useContext(DefaultContext)

  const [isLoading, setIsLoading] = useState(false);
  const [abaSelected, setabaSelected] = useState(0);
  const [products, setproducts] = useState([]);
  const [subCategoriesResponse, setSubCategoriesResponse] = useState([])
  const [showCategoryItems, setshowCategoryItems] = useState(false)
  const [suggestions, setsuggestions] = useState([])

  const [productSearch, setproductSearch] = useState('')

  useEffect(() => {
    if (!open) return formik.resetForm();
    if (categorySelected) {
      const { name, active, order, description, subCategories, products, suggestionId, image_url, saidera = false, orderDelivery } = categorySelected;

      formik.setValues({
        name: name,
        active: active ? 'ativo' : 'inativo',
        order: order,
        description: description,
        suggestionId: suggestionId || 'x',
        orderDelivery,

        subCategories,
        products,

        image: null,
        image_url,
        saidera
      });
    }
  }, [categorySelected, open])

  // Pega as subcategorias
  useEffect(async () => {
    if (establishment) {
      function sort(a, b) {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      }
      async function getSubCategories() {
        const response = await new SubCategoryDB(establishment.id).getAll(where('active', '==', true))
        response.sort(sort);
        setSubCategoriesResponse(response)
      }
      async function getProducts() {
        const products = await new ProductDB(establishment.id).getAll(where('active', '==', true));
        products.sort(sort);
        setproducts(products);
      }
      async function getSuggestions() {
        const suggestions = await new SuggestionDB(establishment.id).getAll(where('active', '==', true))
        suggestions.sort(sort);
        setsuggestions(suggestions)
      }

      getSubCategories();
      getProducts();
      getSuggestions();
    }
  }, [establishment])

  const formik = useFormik({
    initialValues: {
      name: '',
      active: '',
      order: 0,
      description: '',
      suggestionId: 'x',
      orderDelivery: '',

      subCategories: [],
      products: [],

      image: null,
      image_url: null,
      saidera: false,
    },
    validate,
    onSubmit: values => {
      const { name, active, order, description, subCategories, image, saidera = false, products, suggestionId, orderDelivery } = values;
      const data = {
        name: name,
        active: active === 'ativo',
        order: Number(order),
        orderDelivery: Number(orderDelivery),
        description,
        suggestionId: suggestionId === 'x' ? null : suggestionId,
        subCategories,
        products,
        image,
        saidera
      }

      const onSuccess = () => {
        onShowAlert(PreAlert.success('Registro cadastrado com sucesso'))
        setIsClose();
      }
      const onSuccessUpdate = () => {
        onShowAlert(PreAlert.success('Registro atualizado com sucesso'))
        setIsClose();
      }
      const onError = () => {
        onShowAlert(PreAlert.error('Falhou ao cadastrar o registro'))
      }

      setIsLoading(true);
      if (categorySelected) {
        new CategoryDB(establishment.id)
          .update(categorySelected.id, data)
          .then(() => {
            onSuccessUpdate();
            new UserHistory(establishment.id, user, "a Categoria")
              .update(categorySelected.id, { data, selected: categorySelected })
              .finally(() => { })
          })
          .catch(onError)
          .finally(() => setIsLoading(false))
      } else {
        new CategoryDB(establishment.id)
          .create(data)
          .then(() => {
            onSuccess();
            new UserHistory(establishment.id, user, "a Categoria")
              .create(data)
              .finally(() => { })
          })
          .catch(onError)
          .finally(() => setIsLoading(false))
      }
    }
  })


  const handleImage = useCallback((e) => {
    const [file] = Array.from(e.target.files)
    formik.setValues({
      ...formik.values,
      image: file,
      image_url: URL.createObjectURL(file)
    })
  }, [formik.values])

  const handleChangeOrder = useCallback(e => {
    const order = e.target.value.replace(/\D/g, "");
    formik.setValues({
      ...formik.values,
      order
    })
  }, [formik.values])

  const onChangeShowCategory = useCallback((show) => setshowCategoryItems(show), [])
  const optionsSuggestion = useMemo(() => {
    const options = suggestions.map(item => ({ value: item.id, text: item.name }))
    options.unshift({ value: 'x', text: 'Nenhuma' })
    return options;
  }, [suggestions])

  return (
    <Modal
      id={'modal-register-category'}
      titleId={'Cadastro de Categoria'}
      isOpen={open}
      setIsOpen={setIsOpen}
      isStaticBackdrop={true}
      isScrollable={false}
      isCentered={true}
      size="lg" // 'sm' || 'lg' || 'xl' 
      isAnimation={true}
      onSubmit={formik.handleSubmit}
    >
      <ModalHeader setIsOpen={setIsOpen}>
        <ModalTitle id="register-category">{categorySelected ? 'Atualização de Categoria' : 'Cadastro de Categoria'}</ModalTitle>
      </ModalHeader>
      <ModalBody style={showCategoryItems ? { opacity: 0.1, backgroundColor: 'black' } : {}} className='p-5'>
        <form noValidate onSubmit={formik.handleSubmit}>
          {/* Imagem do Categoria */}
          <div className='row align-items-center justify-content-center'>
            <FormGroup
              id='image_url'
              ariaLabel='Logo'
            >
              <Avatar
                id='image_url'
                value={formik.values.image_url}
                onChange={handleImage} />
            </FormGroup>
          </div>
          {/* Inputs */}
          <div className="row pb-2 d-flex">
            {/* Nome */}
            <FormGroup id="name" label="Nome" className='col-md-8 mb-4'>
              <Input
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name || ''}
                isValid={formik.isValid}
                isTouched={formik.touched.name}
                invalidFeedback={formik.errors.name}
                validFeedback='Assim está bom!'
                placeholder='Eletrodomésticos, lâmpadas, etc...'
              />
            </FormGroup>

            {/* Ordem */}
            <FormGroup id="order" label="Ordem" className='col-md-4 mb-4'>
              <Input
                onChange={handleChangeOrder}
                onBlur={formik.handleBlur}
                value={formik.values.order || ''}
                isValid={formik.isValid}
                isTouched={formik.touched.order}
                invalidFeedback={formik.errors.order}
                validFeedback='Assim está bom!'
                placeholder='1, 2, 3, 4, etc...'
              />
            </FormGroup>

            {/* Sugestão */}
            <FormGroup id='suggestionId' label='Sugestão (Opcional)' className='col-md-8 mb-4'>
              <Select
                placeholder='Selecione uma sugestão se desejar'
                list={optionsSuggestion}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.suggestionId}
                isValid={formik.isValid}
                isTouched={formik.touched.suggestionId}
                invalidFeedback={formik.errors.suggestionId}
              />
            </FormGroup>

            {/* Ordem Delivery */}
            <FormGroup id="orderDelivery" label="Ordem no Delivey" className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.orderDelivery || ''}
                  isValid={formik.isValid}
                  isTouched={formik.touched.orderDelivery}
                  invalidFeedback={formik.errors.orderDelivery}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 1'
                />
              </FormGroup>

            {/* Status */}
            <FormGroup className='col-md-4 mb-4'>
              <Label>Status</Label>
              <ChecksGroup
                isValid={formik.isValid}
                isTouched={formik.touched.active}
                invalidFeedback={formik.errors.active}
              >
                <Checks
                  type="radio"
                  id="active"
                  label="Ativo"
                  name="active"
                  value="ativo"
                  onChange={formik.handleChange}
                  checked={formik.values.active}
                  isInline
                />
                <Checks
                  type="radio"
                  id="active2"
                  label="Inativo"
                  name="active"
                  value="inativo"
                  onChange={formik.handleChange}
                  checked={formik.values.active}
                  isInline
                />
              </ChecksGroup>
            </FormGroup>
            {/* Saidera */}
            <FormGroup className='col-md-6 mb-4'>
              <Label>Saideira</Label>
              <ChecksGroup
                isValid={formik.isValid}
                isTouched={formik.touched.saidera}
                invalidFeedback={formik.errors.saidera}
              >
                <Checks
                  type="switch"
                  id="saidera"
                  label="Deve ser considerado para a saideira"
                  name="saidera"
                  value="inativo"
                  onChange={formik.handleChange}
                  checked={formik.values.saidera}
                  isInline
                />
              </ChecksGroup>

            </FormGroup>

            {/* Descrição */}
            <FormGroup id="description" label="Descrição" className='col-md-12 mb-4'>
              <Textarea
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.description || ''}
                isValid={formik.isValid}
                isTouched={formik.touched.description}
                invalidFeedback={formik.errors.description}
                validFeedback='Assim está bom!'
                placeholder='
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur illum hic omnis ipsam fugiat incidunt'
              />
            </FormGroup>

            {/* campo de busca de produtos */}
            <FormGroup className='col-md-4'>
              <Label>Buscar produto</Label>
              <Input
                onChange={e => setproductSearch(e.target.value)}
                value={productSearch}
                placeholder='Digite o nome do produto'
              />
            </FormGroup>
          </div>



          {/* Abas */}
          <Nav
            style={{ marginTop: 20 }}
            tag='ul' // 'ul' || 'nav'
            design='tabs' // 'tabs' || 'pills'
            isFill
          >
            <NavItem
              isActive={abaSelected === 0}
              onClick={() => setabaSelected(0)}>
              <a>
                Produtos
              </a>
            </NavItem>


            <NavItem
              isActive={abaSelected === 1}
              onClick={() => setabaSelected(1)}>
              <a>
                Sub-categorias
              </a>
            </NavItem>
          </Nav>

          {/* Lists */}
          <ListProducts
            hidden={abaSelected !== 0}
            products={products.filter(product => product.name.toLowerCase().includes(productSearch.toLowerCase()))}
            // products={products}
            productsSelected={formik.values.products}
            onChange={formik.handleChange}
          />

          <ListSubCategories
            hidden={abaSelected !== 1}
            products={products}
            categories={subCategoriesResponse}
            categoriesSelected={formik.values.subCategories}
            onChange={formik.handleChange}
            onChangeShowCategory={onChangeShowCategory}
          />

          {/* Buttons */}
          <div className="row pt-4">
            <div className='d-flex justify-content-end gap-2'>
              <Button
                color="danger"
                icon="cancel"
                rounded={1}
                onClick={setIsClose}
                shadow="sm"
                hoverShadow="sm"
                size="sm"
              >
                Cancelar
              </Button>
              {isLoading ? (
                <Button
                  color="success"
                  rounded={1}
                  hoverShadow="sm"
                  shadow="sm"
                  size="sm"
                >
                  <Spinner
                    color="light"
                    inButton
                    isGrow
                    isSmall
                    size={10}
                    tag="span"
                  >
                    Carregando...
                  </Spinner>
                  Carregando...
                </Button>
              ) : (
                <Button
                  isDisable={!formik.isValid}
                  type='submit'
                  color='success'
                  icon="check"
                  rounded={1}
                  hoverShadow="sm"
                  shadow="sm"
                  size="sm"
                >
                  Confirmar
                </Button>
              )}
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal >
  )
}

export default ModalRegisterCategories;
